import { IFoto } from '../trjireh-model';
import { SafeUrl } from '@angular/platform-browser/src/security/dom_sanitization_service';

export class Foto implements IFoto {
    public idFoto: number;
    public archivo: string;
    public tipo: string;
    public valor: string;
    public nombre: string;
    public idTipoArchivo: number;
    public ext: string;
    public comentario: string;
}



// WEBPACK FOOTER //
// C:/Users/stivens/Lab/sonever/repos/taller-web/src/app/core/model/classes/foto.ts